import Notify from '../mixins/notify';
import {isPublicRoute} from "@/helpers/common";

export default function ({ app, redirect, store, error, route, env}) {
  const isLogged = store.state.frontend.auth.isLogged;
  const cookieDomain = env.cookie_domain;
  const cookieSecure = env.cookie_secure;

  app.$axios.onRequest(config => {
    const auth = store.state.frontend.auth;
    if (auth.workspace) {
      config.headers.common['x-workspace'] = auth.workspace;
    }

    const csrfToken = app.$cookies.get('CSRF-TOKEN') || null;
    if (csrfToken) {
      config['headers']['common']['X-XSRF-TOKEN'] = csrfToken;
    }

    return config;
  });

  app.$axios.onResponse(response => {

  });

  app.$axios.onResponseError(err => {
    if (store.state.fromPage === 'admin') {
      const csrfToken = app.$cookies.get('CSRF-TOKEN') || null;
      const tokenMissing = err?.response?.data?.data?.token_missing;
      const isAdminLogged = store?.state?.admin?.auth?.isLogged;
      if ((!csrfToken || tokenMissing) && isAdminLogged) {
        Notify.error({
          title: "トークンの有効期限が切れました。\n再度ログインしてください。",
          width: 600,
        }).then(() => {
          store.commit('admin/auth/setLogged', false);
          window.location.replace('/admin/auth/login');
        });
        return Promise.reject(err);
      }
    }

    if (app.$axios.isCancel(error)) {
      if (store.state.fromPage === 'admin') {
        return redirect(301, '/admin/auth/login');
      }

      return redirect(301, '/auth/login')
    }

    const errResponseData = err.response.data;
    store.commit('setBtnLoading', false, { root: true });
    if (process.server) {
      fromServerAxiosError(err, route);
    } else {
      fromClientAxiosError(err, route);
    }

    return Promise.resolve({
      errResponse: true,
      data: errResponseData,
    });
  });

  const fromServerAxiosError = (err, route) => {
    const code = parseInt(err.response && err.response.status);

    switch (code) {
      case 400:
        const { needWorkspace = false } = err.response.data;
        if (needWorkspace) {
          return redirect('/workspace');
        }
        break;
      case 401:
      case 410:
        if (store.state.fromPage === 'admin') {
          store.commit('admin/auth/setLogged', false);
          app.$cookies.remove('adminToken', {
            path: '/',
            domain: cookieDomain,
            secure: cookieSecure,
            sameSite: 'lax'
          });
          if (!isPublicRoute(route.path)) {
            redirect(301, '/admin/auth/login');
          }

          return;
        }

        store.commit('frontend/auth/setLogged', false);
        app.$cookies.remove('workspace');
        app.$cookies.remove('userToken', {
          path: '/',
          domain: cookieDomain,
          secure: cookieSecure,
          sameSite: 'lax'
        });
        if (!isPublicRoute(route.path)) {
          redirect(301, '/auth/login');
        }

        break;
      default:
        const errResponseData = err.response.data;

        const { needRegister } = errResponseData;
        if (needRegister) {
          return redirect(`/auth/register/${needRegister}`);
        }

        let redirectPath = '/dashboard';
        let redirectText = null;
        if (/^(\/auth\/verify)/.test(route.path)) {
          redirectPath = '/auth/login';
          redirectText = 'ログイン';
        }
        if (store.state.fromPage === 'admin') {
          redirectPath = '/admin';
        }
        return error({
          message: err.response.data.hasOwnProperty('data')
            ?
            Object.values(err.response.data.data)[0][0]
            :
            err.response?.data?.message ||
            (`${err.response.status} - ${err.response.statusText}`) ||
            'Server Error',
          redirectPath,
          redirectText,
          statusCode: err.response.status
        });
    }
  };

  const fromClientAxiosError = (err) => {
    const code = parseInt(err.response && err.response.status);
    switch (code) {
      case 401:
      case 410:
        if (store.state.fromPage === 'admin') {
          store.commit('admin/auth/setLogged', false);
          store.commit('hidePageLoading', true, {root: true});
          app.$cookies.remove('adminToken', {
            path: '/',
            domain: cookieDomain,
            secure: cookieSecure,
            sameSite: 'lax'
          });

          if (!isPublicRoute(route.path)) {
            redirect(301, '/admin/auth/login');
          }

          return;
        }

        store.commit('frontend/auth/setLogged', false);
        app.$cookies.remove('workspace');
        app.$cookies.remove('userToken', {
          path: '/',
          domain: cookieDomain,
          secure: cookieSecure,
          sameSite: 'lax'
        });
        store.commit('hidePageLoading');

        if (!isPublicRoute(route.path)) {
          redirect(301, '/auth/login');
        }

        break;
      case 400:
        const { needWorkspace = false } = err.response.data;
        if (needWorkspace) {
          return redirect('/workspace');
        }

        store.commit('setErrors', err.response.data.data, { root: true });
        break;
      case 500:
        Notify.error({
          title: err.response.data.message,
          text: "エラーコード：" + err.response.data.rid,
          customClass: {
            content: 'error-code',
          },
          allowOutsideClick: true,
          showCloseButton: true
        });
        throw new Error(`${err.response.statusText}`);
      case 403:
        if ($nuxt.$route.name === 'group-chats') {
          store.dispatch('frontend/chat/SET_SELECTED_CHANNEL', null)
          break
        }
      default:
        Notify.error({
          title: err.response.data.message,
          text: "エラーコード：" + err.response.data.rid,
          customClass: {
            content: 'error-code',
          }
        });
    }
  };
}
